// @file    fa-to-lucide.pipe.ts
// @created 2026-07-01 by Claude
// @desc    Converts a Font Awesome class string (e.g. 'fa-solid fa-house',
//          'fa-house', or a bare 'house') into the Lucide kebab name used by
//          <lucide-icon [name]="...">. Lets .ihx templates render Lucide from
//          the SAME dynamic icon fields the legacy (!useNewUi) templates still
//          render as FA <i> — so the .ts data needs no change.

import { Pipe, PipeTransform } from '@angular/core';
import { FA_LUCIDE, LUCIDE_FALLBACK } from './fa-lucide.map';

@Pipe({ name: 'faToLucide', standalone: true })
export class FaToLucidePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return LUCIDE_FALLBACK;
    // pick the first token that resolves to a known FA glyph (skips
    // 'fa-solid', 'fa-spin', etc. which aren't map keys)
    for (const tok of value.trim().split(/\s+/)) {
      const bare = tok.replace(/^fa-/, '');
      if (FA_LUCIDE[bare]) return FA_LUCIDE[bare];
    }
    // already a lucide name? (a target value passed straight through)
    const bareWhole = value.trim().replace(/^fa-/, '');
    if (Object.values(FA_LUCIDE).includes(bareWhole)) return bareWhole;
    return LUCIDE_FALLBACK;
  }
}
